import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { NzCascaderOption } from 'ng-zorro-antd/cascader';
@Component({
  selector: 'app-input-cascader',
  templateUrl: './input-cascader.component.html',
  styleUrl: './input-cascader.component.scss',
})
export class InputCascaderComponent {
  @Input() placeholder: string = 'please Select';
  @Input() isDisabled: boolean = false;
  @Input() label: string = '';
  @Input() control: FormControl = new FormControl();
  @Input() size: 'default' | 'large' | 'small' = 'small';
  @Input() nzOptions: NzCascaderOption[] = [];

  onChanges(values: string[]): void {}

  isRequired(control: AbstractControl | null): boolean {
    if (!control || !control.validator) {
      return false;
    }
    const validator = control.validator({} as AbstractControl);
    return validator && validator['required'] ? true : false;
  }
}
